<template>
    <div>
        <div id="hometop">
            <!--轮播图片-->
            <div class="bannerdiv">
                <div id="full-screen-slider">
                    <swiper id="slides" ref="mySwiper" :options="swiperOptions">
                        <swiper-slide v-for="(item, index) in bannerList" :key="index"
                            :class="{ current: index === currentIndex }">
                            <div class="image-container">
                                <img v-lazy="item.picture" alt="">
                            </div>
                            <a href="http://www.zlqy.com.cn/" target="_blank"></a>
                        </swiper-slide>
                    </swiper>
                </div>
            </div>

            <!--顶部导航-->
            <!-- <div class="hometop">
                <div class="homece">
                    <a href="http://www.zlqy.com.cn/index/home.html">中文</a>
                    <a href="http://www.zlqy.com.cn/en/index/home.html">ENG</a>
                </div>
                <div class="home_logo">
                    <a href="http://www.zlqy.com.cn/"><img src=""></a>
                </div>
                <div id="header_title">
                    <span class="c0">
                        <p><a href="http://www.zlqy.com.cn/" class="current">首页</a></p>
                    </span>

                    
                    <span class="c1">
                        <p><a href="http://www.zlqy.com.cn/about/index.html">走进中磊</a></p>
                        <ul style="display: none;">
                            <li><a href="http://www.zlqy.com.cn/about/view_1.html">中磊陶瓷集团介绍</a></li>
                            <li><a href="http://www.zlqy.com.cn/about/view_2.html">中磊陶瓷集团优势</a></li>
                            <li><a href="http://www.zlqy.com.cn/about/view_3.html">中磊陶瓷集团文化</a></li>
                            <li><a href="http://www.zlqy.com.cn/about/view_4.html">中磊陶瓷集团品牌</a></li>
                            <li><a href="http://www.zlqy.com.cn/about/honor.html">中磊陶瓷集团荣誉</a></li>
                            <li><a href="http://www.zlqy.com.cn/about/partners.html">战略合作伙伴</a></li>
                            <li><a href="http://www.zlqy.com.cn/about/videoDescription.html">视频欣赏</a></li>
                        </ul>
                    </span>

                    
                    <span class="c1">
                        <p><a href="http://www.zlqy.com.cn/product/index.html">中磊产品</a></p>
                        <ul style="display: none;">
                            <li><a href="http://www.zlqy.com.cn/product/category_1.html">景观砖</a></li>
                            <li><a href="http://www.zlqy.com.cn/product/category_2.html">传统之美</a></li>
                            <li><a href="http://www.zlqy.com.cn/product/category_3.html">创新之星</a></li>
                            <li><a href="http://www.zlqy.com.cn/product/category_4.html">智美应用</a></li>
                            <li><a href="http://www.zlqy.com.cn/product/category_5.html">石尚生活</a></li>
                        </ul>
                    </span>

                    
                    <span class="c2">
                        <p><a href="http://www.zlqy.com.cn/cases/index.html">工程案例</a></p>
                        <ul style="display: none;">
                            <li><a href="http://www.zlqy.com.cn/cases/category_1.html">工程案例图</a></li>
                        </ul>
                    </span>

                    
                    <span>
                        <p><a href="http://www.zlqy.com.cn/crafts/index.html">生产工艺</a></p>
                        <ul style="display: none;">
                            <li><a href="http://www.zlqy.com.cn/crafts/view_1.html">生产工艺</a></li>
                            <li><a href="http://www.zlqy.com.cn/crafts/view_2.html">生产流程</a></li>
                            <li><a href="http://www.zlqy.com.cn/crafts/view_3.html">施工指引</a></li>
                        </ul>
                    </span>

                    
                    <span>
                        <p><a href="http://www.zlqy.com.cn/news/index.html">新闻动态</a></p>
                        <ul style="display: none;">
                            <li><a href="http://www.zlqy.com.cn/news/category_1.html">公司新闻</a></li>
                            <li><a href="http://www.zlqy.com.cn/news/category_2.html">中磊公告</a></li>
                            <li><a href="http://www.zlqy.com.cn/news/category_3.html">项目动态</a></li>
                        </ul>
                    </span>

                    
                    <span class="last">
                        <p><a href="http://www.zlqy.com.cn/contact/index.html">联系我们</a></p>
                        <ul style="display: none;">
                            <li><a href="http://www.zlqy.com.cn/contact/view_1.html">联系方式</a></li>
                            <li><a href="http://www.zlqy.com.cn/contact/message.html">在线留言</a></li>
                        </ul>
                    </span>
                </div>
            </div> -->

            <!--轮播文字介绍-->
            <div class="banner">
                <div class="bannerbg">
                    <div class="bannerlist">
                        <li @mouseover="showSlide(index)" :class="{ current: index === currentIndex }"
                            v-for="(item,index) in bannerList" :key="index">
                            <a href="/home">
                                <span class="s1">{{item.title}}</span>
                                <span>{{item.description}}</span>
                            </a>
                        </li>
                    </div>
                </div>
            </div>
        </div>

        <div id="home_bottom">

            <!--新闻动态列表-->
            <div class="home_news">
                <div class="home_header_title">
                    <span class="cn">新闻动态</span>
                    <span class="en">NEWS</span>
                    <span class="more">
                        <router-link v-if="newsList.length>0" :to="{path:'/news',query:{category_id:newsList[0].id}}">更多
                            +&gt;</router-link>
                    </span>
                </div>

                <div class="one_news">
                    <router-link v-if="newsList.length>0" :to="{path:'/news',query:{category_id:newsList[0].id}}">
                        <img src="@/assets/images/1.jpg">
                        <span>项目动态</span>
                    </router-link>
                </div>

                <div v-for="(item,index) in news.slice(0,2) " :key="index" class="news_li">
                    <router-link :to="{path:'/newsdetail',query:{category_id:item.category_id,id:item.id}}">
                        <span>{{item.created_at}}&gt;</span>
                        {{item.title}}
                    </router-link>
                </div>

            </div>

            <!--关于我们-->
            <div class="home_about" v-if="aboutList.length>0">
                <div class="home_header_title">
                    <span class="cn">关于我们</span>
                    <span class="en">ABOUT</span>
                    <span class="more">
                        <router-link :to="{path:'/about',query:{category_id:aboutList[0].id}}">更多 +&gt;</router-link>
                    </span>
                </div>
                <div class="one_about">
                    <img src="@/assets/images/2.jpg">
                    <span>{{$deTag(aboutList[0].content)}}</span>
                </div>
            </div>

            <!--工程案例-->
            <div class="home_case">
                <div class="home_header_title">
                    <span class="cn">工程案例</span>
                    <span class="en">CASE</span>
                    <span class="more">
                        <router-link :to="{path:'/case',query:{category_id:casesList[0]?.id}}">更多 +&gt;</router-link>
                    </span>
                </div>
                <div class="one_case">
                    <div class="case_hidden">
                        <router-link v-for="(item,index) in cases" :key="index"
                            :to="{path:'/case',query:{category_id:item.category_id}}">
                            <img :src="item.picture">
                        </router-link>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import Swiper from 'swiper';
    export default {
        data() {
            return {
                currentIndex: 0,
                bannerList: [],
                aboutList: [],
                news: [],
                cases: [],
                casesList: [],
                newsList: [],
                craftsList: [],
                swiperOptions: {
                    effect: 'fade', //渐变
                    fadeEffect: { //交叉渐变
                        crossFade: true,
                        duration: 1000
                    },
                    speed: 1000, // 切换时间设置为1.5秒
                    navigation: {
                        nextEl: ".next",
                        prevEl: ".prev"
                    }
                },

            }
        },
        mounted() {
            this.getBanner();
            this.getAbout();
            this.getCrafts();
            this.getCase();
            this.getCaseCategory();
            this.getNews();
            this.getNewsCategory();
            this.$nextTick(() => {
                this.startAutoPlay();
            });
        },
        beforeDestroy() {
            this.stopAutoPlay();
        },
        methods: {
            async getBanner() {
                const res = await this.$request.post('banner/getAll')
                if (res.data.code === 0) {
                    this.bannerList = res.data.data;

                }
            },
            async getAbout() {
                const res = await this.$request.post('about/getAll')
                if (res.data.code === 0) {
                    this.aboutList = res.data.data
                }
            },
            async getNews() {
                const res = await this.$request.post('news/getAll')
                if (res.data.code === 0) {
                    this.news = res.data.data.data
                    this.news.forEach(item => {
                        item.created_at = item.created_at.split(' ')[0]
                    })
                }
            },
            async getCase() {
                const res = await this.$request.post('cases/getPaginate')
                if (res.data.code === 0) {
                    this.cases = res.data.data.data
                    this.cases = this.cases.slice(0, 4)
                }
            },
            async getCaseCategory() {
                const res = await this.$request.post('casescategory/getAll')
                if (res.data.code === 0) {
                    this.casesList = res.data.data
                }
            },
            async getNewsCategory() {
                const res = await this.$request.post('newscategory/getAll')
                if (res.data.code === 0) {
                    this.newsList = res.data.data
                }
            },
            async getCrafts() {
                const res = await this.$request.post('crafts/getAll')
                if (res.data.code === 0) {
                    this.craftsList = res.data.data
                }
            },
            navigateTo(path, query) {
                this.$router.push({ path, query });
            },
            showSlide(index) {
                this.$nextTick(() => {
                    this.$refs.mySwiper.swiper.slideTo(index);
                });
                this.currentIndex = index;
            },
            startAutoPlay() {
                this.interval = setInterval(() => {
                    this.currentIndex = (this.currentIndex + 1) % this.bannerList.length;
                    this.$refs.mySwiper.swiper.slideTo(this.currentIndex);
                }, 4000);
            },
            stopAutoPlay() {
                clearInterval(this.interval);
            }
        },
    }
</script>

<style lang="css" scoped>
    .home_img_container {
        position: relative;
    }

    .overlay-svg {
        position: absolute;
        /* 设置为绝对定位 */
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
        /* 设置z-index高于图片，使其显示在图片上方 */
    }

    .image-container{
        display: flex;
        justify-content: center;
    }

</style>